import { mapGetters } from 'vuex'
/**
 * 该模块主要用于合并入双胞胎页面
 * App.vue初始化时，监听message事件，传入数据到store中。
 * store中的message变化后，混入该模块的双胞胎页将根据传入参数触发对应事件
 * 使用方式待修正
 */
export default {
  // 增加监听父页面传值方案
  computed: {
    ...mapGetters([
      'getMessageData'
    ])
  },
  watch: {
    getMessageData(msg) {
      for (let key in msg) {
        if (this[key]) this[key](msg[key])
      }
    }
  }
}
